/*global drupalSettings*/
/*global Drupal*/
let langPrefix = '';
if(drupalSettings.cc_autocomplete_search.multilingual) {
    langPrefix = '/' + drupalSettings.path.currentLanguage;
}

let apiEndpoint = "/solr-search-api/";
if(drupalSettings.cc_autocomplete_search.api_path){
    apiEndpoint = drupalSettings.cc_autocomplete_search.api_path;
    if (apiEndpoint.charAt(0) !== "/") apiEndpoint = "/" + apiEndpoint;
    if (apiEndpoint.charAt(apiEndpoint.length - 1) !== "/") apiEndpoint = apiEndpoint + "/";
}
apiEndpoint = langPrefix + apiEndpoint;

let searchUri = "/zoeken?search_api_fulltext=";
if(drupalSettings.cc_autocomplete_search.search_path){
    searchUri = drupalSettings.cc_autocomplete_search.search_path;
    if (searchUri.charAt(0) != "/") searchUri = "/" + searchUri;
}
searchUri = langPrefix + searchUri;
let placeholder = drupalSettings.cc_autocomplete_search.placeholder ? drupalSettings.cc_autocomplete_search.placeholder : "search";
let noResults = drupalSettings.cc_autocomplete_search.no_results ? drupalSettings.cc_autocomplete_search.no_results : "No results.";

export {apiEndpoint,searchUri, placeholder, noResults};


// WEBPACK FOOTER //
// ./src/helpers.js